import { phoneFormatter } from "./phone-formatter";

export const { isValidNumber, formatE164 } = phoneFormatter;
